// extracted by mini-css-extract-plugin
export default {"detailWrapper":"jobDetails_detailWrapper__BLmN3","flexCenter":"jobDetails_flexCenter__pMVrJ"};